export default __webpack_public_path__ + "static/media/design_solution.860ee653.jpg";